import { SEO } from '../components/SEO';

export function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="Read the terms and conditions for using ByteJourney. Understand your rights and responsibilities as a user."
        canonical="/terms"
      />
      <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: December 2025</p>

      <div className="prose prose-gray max-w-none space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 leading-relaxed">
            By accessing and using ByteJourney ("the Service"), you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">2. Description of Service</h2>
          <p className="text-gray-700 leading-relaxed">
            ByteJourney is a blogging platform that allows users to write, publish, and share articles.
            The Service includes features for creating content, uploading images, and engaging with other users through comments.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">3. User Accounts</h2>
          <p className="text-gray-700 leading-relaxed mb-4">To use certain features of the Service, you must:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Sign in using your Google account</li>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account</li>
            <li>Be at least 13 years of age</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            You are responsible for all activities that occur under your account.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">4. User Content</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            You retain ownership of the content you create on ByteJourney. By publishing content, you grant us a
            non-exclusive, worldwide license to display, distribute, and promote your content on the platform.
          </p>
          <p className="text-gray-700 leading-relaxed">You agree not to post content that:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
            <li>Violates any laws or regulations</li>
            <li>Infringes on intellectual property rights of others</li>
            <li>Contains hate speech, harassment, or discrimination</li>
            <li>Includes spam, malware, or deceptive content</li>
            <li>Contains explicit or inappropriate material without proper warnings</li>
            <li>Impersonates others or misrepresents your identity</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">5. Acceptable Use</h2>
          <p className="text-gray-700 leading-relaxed mb-4">When using the Service, you agree to:</p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Respect other users and their content</li>
            <li>Not attempt to gain unauthorized access to the Service</li>
            <li>Not interfere with the proper functioning of the Service</li>
            <li>Not use automated systems to access the Service without permission</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">6. Content Moderation</h2>
          <p className="text-gray-700 leading-relaxed">
            We reserve the right to remove any content that violates these terms or that we deem inappropriate.
            We may also suspend or terminate accounts that repeatedly violate our policies.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">7. Intellectual Property</h2>
          <p className="text-gray-700 leading-relaxed">
            The ByteJourney name, logo, and platform design are our intellectual property.
            You may not use our branding without explicit permission.
            User-generated content remains the property of its respective creators.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">8. Disclaimer of Warranties</h2>
          <p className="text-gray-700 leading-relaxed">
            The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service
            will be uninterrupted, secure, or error-free. We are not responsible for the accuracy or reliability
            of user-generated content.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">9. Limitation of Liability</h2>
          <p className="text-gray-700 leading-relaxed">
            To the maximum extent permitted by law, ByteJourney shall not be liable for any indirect, incidental,
            special, or consequential damages arising from your use of the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">10. Changes to Terms</h2>
          <p className="text-gray-700 leading-relaxed">
            We may modify these terms at any time. Continued use of the Service after changes constitutes
            acceptance of the new terms. We will notify users of significant changes.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">11. Termination</h2>
          <p className="text-gray-700 leading-relaxed">
            You may stop using the Service at any time. We reserve the right to suspend or terminate your access
            to the Service for violations of these terms or for any other reason at our discretion.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">12. Contact</h2>
          <p className="text-gray-700 leading-relaxed">
            If you have questions about these Terms of Service, please contact us through our platform.
          </p>
        </section>
      </div>
      </div>
    </>
  );
}
